// Financiación / Cuotas por WhatsApp
// Cambiar a true para habilitar el módulo
export const FINANCIACION_HABILITADA = false;
